<template>
	<div class="secondReview">
		<!-- 二次审核主要弹窗 -->
		<el-dialog
			title="二次审核"
			custom-class="secondReview_Dialog"
			:append-to-body="true"
			:close-on-click-modal="false"
			:visible.sync="dialogVisible"
			@close="closeDialog"
			width="50%"
		>
			<div class="dialog-content" v-loading="nextLoading">
				<el-descriptions :column="2">
					<el-descriptions-item label="客户名称">{{
						inquirySecondReviewDetails.custName || '-'
					}}</el-descriptions-item>
					<el-descriptions-item label="域名">{{
						inquirySecondReviewDetails.domianName || '-'
					}}</el-descriptions-item>
					<el-descriptions-item label="审核人">{{
						inquirySecondReviewDetails.auditName || '-'
					}}</el-descriptions-item>
					<el-descriptions-item label="审核时间">{{
						inquirySecondReviewDetails.auditTime || '-'
					}}</el-descriptions-item>
					<el-descriptions-item label="询盘邮箱/手机号" :span="2">{{
						`${inquirySecondReviewDetails.inquiryEmail || '-'}/${
							inquirySecondReviewDetails.phone || '-'
						}`
					}}</el-descriptions-item>
					<el-descriptions-item label="询盘时间">{{
						inquirySecondReviewDetails.inquiryTime || '-'
					}}</el-descriptions-item>
					<el-descriptions-item label="询盘类型">{{
						inquirySecondReviewDetails.inquiryTypeStr || '-'
					}}</el-descriptions-item>
					<el-descriptions-item label="系统判定垃圾原因" :span="2">
						<div
							class="filterRemarks"
							v-html="inquirySecondReviewDetails.filterRemarks || '-'"
						></div>
					</el-descriptions-item>
					<el-descriptions-item label="询盘内容" :span="2">
						<div class="inquiryContent" ref="inquiryContentRef"></div>
					</el-descriptions-item>
				</el-descriptions>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button
					v-clipboard:copy="inquirySecondReviewDetails.inquiryContent"
					v-clipboard:success="copySuccess"
					>复制询盘内容</el-button
				>
				<el-button
					type="warning"
					v-if="
						inquirySecondReviewDetails.reviewStatus !== undefined &&
						inquirySecondReviewDetails.reviewStatus === 0
					"
					:disabled="nextLoading"
					:loading="noGarbageLoading"
					@click="noGarbage"
					>这不是垃圾</el-button
				>
				<el-button
					type="primary"
					:loading="nextLoading"
					:disabled="noGarbageLoading"
					@click="() => isGarbage()"
					>{{
						inquirySecondReviewDetails.reviewStatus !== undefined &&
						inquirySecondReviewDetails.reviewStatus === 0
							? '这是垃圾，下一封'
							: '下一封'
					}}</el-button
				>
			</div>
		</el-dialog>

		<!-- 二次审核判定二次确认弹窗 -->
		<el-dialog
			title="提示"
			custom-class="confirmDialog"
			:visible.sync="confirmVisible"
			:close-on-click-modal="false"
			width="20%"
			center
		>
			<div class="confirmVisible_content">
				<div class="tips">确认非垃圾后，该询盘会二次推送给客户，请谨慎确认</div>
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="() => (confirmVisible = false)">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import enquiry from '@/backend/services/enquiry/enquiry.js';
import vm from '@/common/confirm.js';

export default {
	name: 'secondReview',
	props: ['idList'],
	components: {},
	data() {
		return {
			// 主弹窗显示状态
			dialogVisible: false,
			// 二次弹窗显示状态
			confirmVisible: false,
			// 下次不再提示
			checked: false,
			// 详情
			inquirySecondReviewDetails: {},
			// 当前id
			id: null,
			// 下一封按钮加载状态
			nextLoading: false,
			// 这不是垃圾加载状态
			noGarbageLoading: false,
		};
	},
	computed: {
		// 当前ID在ID列表中的索引
		currentIndex(self) {
			return self.idList.indexOf(self.id);
		},
	},
	methods: {
		// 打开弹窗
		async openDialog(id) {
			this.id = id;
			// 1. 先显示弹窗，触发DOM渲染
			this.dialogVisible = true;
			// 2. 等待弹窗DOM完全渲染（第一次打开时必须）
			await this.$nextTick();
			// 3. 再获取数据并渲染内容
			await this.getInquirySecondReviewDetails(id);
		},
		// 关闭弹窗
		async closeDialog() {
			this.dialogVisible = false;
			this.confirmVisible = false;
			this.id = null;
			this.nextLoading = false;
			this.noGarbageLoading = false;
			this.inquirySecondReviewDetails = {};
		},
		// 获取二次审核询盘详情
		async getInquirySecondReviewDetails(summaryId) {
			try {
				this.nextLoading = true;
				const res = await enquiry.inquirySecondReview({ summaryId });
				this.inquirySecondReviewDetails = res.data;

				// 等待数据更新到DOM后，再渲染询盘内容（确保ref元素存在）
				this.$nextTick(() => {
					this.renderInquiryContent();
				});
			} catch (error) {
				console.error('获取审核详情失败:', error);
			} finally {
				this.nextLoading = false;
			}
		},

		/**
		 * 渲染询价内容到Shadow DOM
		 * 避免XSS风险并确保DOM操作安全性
		 */
		renderInquiryContent() {
			// 解构时添加默认值，避免数据不存在导致的报错
			const { inquirySecondReviewDetails = {} } = this;
			const { inquiryContent = '' } = inquirySecondReviewDetails;

			// 检查DOM元素是否存在
			const contentElement = this.$refs.inquiryContentRef;
			if (!contentElement) {
				console.warn('未找到inquiryContentRef元素，无法渲染内容');
				return;
			}

			// 处理Shadow DOM：如果已存在则复用，避免重复创建报错
			const shadowRoot = contentElement.shadowRoot || contentElement.attachShadow({ mode: 'open' });

			// 清空原有内容，避免重复渲染
			shadowRoot.innerHTML = '';

			// 创建内容容器并设置内容
			const contentContainer = document.createElement('div');
			// 注意：innerHTML存在XSS风险，如果内容来自用户输入，建议使用DOMPurify等库净化
			contentContainer.innerHTML = inquiryContent;

			// 挂载到shadow root
			shadowRoot.appendChild(contentContainer);
		},
		// 复制成功提示
		copySuccess(e) {
			if (e) vm._success('复制成功');
		},
		// 下一封
		async next(isSuccess) {
			this.nextLoading = true;
			let { currentIndex, idList } = this;
			let id;

			// 如果当前索引是最后一个，则抛出翻页操作
			if (currentIndex === idList.length - 1) {
				// 翻页
				this.$emit('changePage');
				return;
			} else id = idList[currentIndex + 1];
			if (isSuccess) this.$emit('query');
			this.id = id;
			this.getInquirySecondReviewDetails(id);
		},
		// 判定为垃圾
		async isGarbage() {
			let { inquirySecondReviewDetails } = this;
			let { reviewStatus } = inquirySecondReviewDetails;

			if (reviewStatus !== undefined && reviewStatus === 0) this.inquirySecondReviewGarbageAudit();
			else this.next();
		},
		// 判定为非垃圾
		async noGarbage() {
			const isShow = localStorage.getItem('secondReview_confirmDialog');
			if (!isShow) this.confirmVisible = true;
			else this.inquirySecondReviewAudit();
		},
		// 二次确认弹窗确认
		confirm() {
			let { checked } = this;
			if (checked) localStorage.setItem('secondReview_confirmDialog', checked);
			this.confirmVisible = false;
			this.inquirySecondReviewAudit();
		},
		//  二次审核询盘审核
		async inquirySecondReviewAudit() {
			this.noGarbageLoading = true;

			let { inquirySecondReviewDetails } = this;
			let { id } = inquirySecondReviewDetails;
			let res = await enquiry.inquirySecondReviewAudit({
				id,
			});
			if (res.data) {
				this.$message.success('审核成功');
				this.noGarbageLoading = false;
				this.next(true);
			}
		},
		// 垃圾询盘二次审核
		async inquirySecondReviewGarbageAudit() {
			try {
				this.nextLoading = true;

				let { inquirySecondReviewDetails } = this;
				let { id } = inquirySecondReviewDetails;
				let res = await enquiry.inquirySecondReviewGarbageAudit({
					id,
				});
				if (res.data) {
					this.$message.success('审核成功');
					this.next(true);
				}
			} catch (error) {
				this.noGarbageLoading = false;
				this.nextLoading = false;
			}
		},
		// 翻页时重置到第一条数据
		reset() {
			let { idList } = this;
			if (this.dialogVisible && idList.length !== 0) {
				this.id = idList[0];
				this.getInquirySecondReviewDetails(idList[0]);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.secondReview {
	::v-deep .confirmDialog {
		.el-dialog__body {
			padding-bottom: 10px;
		}

		.confirmVisible_content {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.tips {
				font-size: 17px;
				font-weight: 550;
				margin-bottom: 20px;
			}
		}
	}
}
</style>

<style lang="scss">
.secondReview_Dialog {
	margin-top: 20px !important;
	width: 50%;
	height: 95%;
	display: flex;
	flex-direction: column;

	.el-dialog__body {
		flex: 1;

		.dialog-content {
			height: 100%;

			.el-descriptions {
				height: 100%;

				.el-descriptions__body {
					height: 100%;

					.el-descriptions__table {
						height: 100%;
						display: flex;
						flex-direction: column;

						tbody:last-child {
							flex: 1;
							position: relative;

							.el-descriptions-item__container {
								width: 100%;
								position: absolute;
								height: 100%;
							}
						}

						.el-descriptions-row {
							display: flex;

							.el-descriptions-item {
								flex: 1;
							}
						}
					}
				}
			}
		}
	}

	.el-descriptions {
		.filterRemarks {
			white-space: pre-wrap;
		}

		.inquiryContent {
			padding: 10px;
			background-color: rgba(242, 242, 242, 1);
			border-radius: 5px;
			width: 90%;
			height: 100%;
			overflow: auto;
		}
	}
}
</style>
